var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.availableLocales),function(locale){return _c('a',{key:locale.key,class:locale.key === _vm.selected ? 'selected' : '',on:{"click":function($event){$event.preventDefault();return _vm.selectLocale(locale)}}},[_vm._v(" "+_vm._s(locale.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }